/**
 * Candidate status funnel (matches backend CandidateStatus enum).
 * Tree is for UI hierarchy only — values are flat strings in API/DB.
 */

export const CANDIDATE_STATUS_TREE = [
    { label: "Первичный отбор", tone: "red", children: [{ value: "неразобранный" }, { value: "холодный поиск" }] },
    { label: "Тест", tone: "red", children: [{ value: "тест: отправлен" }, { value: "тест: звонок" }, { value: "тест: пройден (частично)" }, { value: "тест: пройден" }] },
    { label: "Собес", tone: "amber", children: [{ value: "собес: назначен" }, { value: "собес: не пришёл" }, { value: "собес: перенос" }, { value: "собес: ожидает решения" }] },
    { label: "Тест день", tone: "amber", children: [{ value: "тест день: назначен" }, { value: "тест день: ожидает решения" }, { value: "тест день: не пришёл" }] },
    { label: "Оффер", tone: "green", children: [{ value: "оффер: отправлен" }, { value: "оффер: принят" }] },
    { label: "Обучение", tone: "green", children: [{ value: "обучение" }] },
    { label: "ВНР", tone: "green", children: [{ value: "ВНР: запрос документов" }, { value: "ВНР: документы направлены" }] },
    { label: "Адаптация", tone: "green", children: [{ value: "адаптация: 1 неделя" }, { value: "адаптация: 1 месяц" }, { value: "адаптация: 2 месяца" }] },
    { label: "В штате", tone: "green", children: [{ value: "в штате" }] },
    { label: "НДЗ", tone: "grey", children: [{ value: "НДЗ: тест" }] },
    { label: "Не подходит", tone: "grey", children: [{ value: "не подходит: резюме" }, { value: "не подходит: тест" }, { value: "не подходит: звонок" }, { value: "не подходит: собес" }, { value: "не подходит: тест день" }, { value: "не подходит: оффер" }] },
    { label: "Отказался", tone: "grey", children: [{ value: "отказался: тест" }, { value: "отказался: собес" }, { value: "отказался: тест день" }, { value: "отказался: оффер" }, { value: "отказался: обучение" }, { value: "отказался: ВНР" }] },
    { label: "Увольнение", tone: "grey", children: [{ value: "увольнение: 1 неделя" }, { value: "увольнение: 1 месяц" }, { value: "увольнение: 2 месяца" }, { value: "увольнение: дата" }] },
];

export const DATE_STATUS_VALUES = new Set(["собес: назначен", "собес: перенос", "собес: ожидает решения", "тест день: назначен", "тест день: ожидает решения", "ВНР: запрос документов", "ВНР: документы направлены", "адаптация: 1 неделя", "адаптация: 1 месяц", "адаптация: 2 месяца", "увольнение: дата"]);
export const LEGACY_STATUS_MAP = { "холодный контакт": "холодный поиск", "откликнулся": "неразобранный", "тест: не прошли": "не подходит: тест", "психологический тест: пройден": "тест: пройден (частично)", "профессиональный тест: пройден": "тест: пройден", "собес": "собес: назначен", "подумать": "собес: ожидает решения", "оффер принят": "оффер: принят", "Full documents": "ВНР: документы направлены", "не подходит": "не подходит: резюме", "отказ": "не подходит: собес", "отказался": "отказался: собес", "ВНР": "в штате", "уволился": "увольнение: дата" };

export const ARCHIVE_STATUS_VALUES = new Set([
    ...CANDIDATE_STATUS_TREE.slice(10, 12).flatMap((section) => section.children.map((item) => item.value)),
    "увольнение: дата", "не подходит", "отказался", "отказ", "уволился",
]);

export const HIRE_STATUS_VALUE = "в штате";

export const STATUS_LABELS = {
    ...Object.fromEntries(CANDIDATE_STATUS_TREE.flatMap((section) => section.children.map((item) => [item.value, item.value.charAt(0).toUpperCase() + item.value.slice(1)]))),
    "собес: назначен": "Собес", "тест день: назначен": "Тест день", "увольнение: дата": "Увольнение",
    "собес: перенос": "Собес: перенос на",
    "собес: не пришёл": "Собес: не пришел", "тест день: не пришёл": "Тест день: не пришел",
    "холодный контакт": "Холодный контакт",
    "не подходит": "Не подходит",
    "отказался": "Отказался",
    "откликнулся": "Откликнулся",
    "тест: отправлен": "Тест отправлен",
    "тест: не прошли": "Тест не пройден",
    "тест: пройден": "Тест пройден",
    "психологический тест: пройден": "Психологический тест пройден",
    "профессиональный тест: пройден": "Профессиональный тест пройден",
    собес: "Собеседование",
    подумать: "Подумать",
    "оффер принят": "Оффер принят",
    "Full documents": "Полный пакет документов",
    отказ: "Отказ",
    ВНР: "Вышел на работу",
    уволился: "Уволился",
};

export const STATUS_NEXT_ACTIONS = {
    "холодный контакт": "Связаться с кандидатом",
    "не подходит": "При необходимости вернуть в подбор",
    отказался: "При необходимости вернуть в подбор",
    откликнулся: "Провести первичный разбор",
    "тест: отправлен": "Дождаться результата теста",
    "тест: звонок": "Провести звонок и зафиксировать результат",
    "тест: не прошли": "Вернуть в подбор или оставить в архиве",
    "тест: пройден": "Назначить собеседование",
    "психологический тест: пройден": "Открыть результаты или назначить собеседование",
    "профессиональный тест: пройден": "Открыть результаты или назначить собеседование",
    собес: "Провести собеседование и зафиксировать решение",
    подумать: "Вернуться к решению по кандидату",
    "оффер принят": "Запросить документы для трудоустройства",
    "Full documents": "Подтвердить выход на работу",
    отказ: "При необходимости вернуть в подбор",
    ВНР: "Сопровождать сотрудника",
    уволился: "Карточка завершена",
};

export const STATUS_STAGES = {
    "холодный контакт": "Поиск", "не подходит": "Первичный отбор", отказался: "Подбор завершён",
    откликнулся: "Первичный отбор", "тест: отправлен": "Тестирование", "тест: звонок": "Тестирование", "тест: не прошли": "Тестирование",
    "тест: пройден": "Тестирование", "психологический тест: пройден": "Тестирование",
    "профессиональный тест: пройден": "Тестирование", собес: "Собеседование", подумать: "Принятие решения",
    "оффер принят": "Оформление", "Full documents": "Оформление", отказ: "Подбор завершён",
    ВНР: "Трудоустройство", уволился: "Трудоустройство",
};

export const STATUS_STATES = {
    "холодный контакт": "Контакт ещё не установлен", "не подходит": "Завершён: кандидат не подходит",
    отказался: "Архив: отказ кандидата", откликнулся: "Ожидает рассмотрения",
    "тест: отправлен": "Ожидается результат", "тест: звонок": "Ожидается звонок", "тест: не прошли": "Результат: не пройден",
    "тест: пройден": "Результат: пройден", "психологический тест: пройден": "Психологический тест завершён",
    "профессиональный тест: пройден": "Профессиональный тест пройден", собес: "В работе", подумать: "Решение отложено",
    "оффер принят": "Оффер принят кандидатом", "Full documents": "Документы собраны",
    отказ: "Архив: отказ работодателя", ВНР: "Сотрудник работает", уволился: "Архив: сотрудник уволился",
};

export const CARD_STATUS_ACTIONS = [
    { status: "собес: назначен", label: "На собеседование", tone: "sky" },
    { status: "собес: ожидает решения", label: "Ожидает решения", tone: "amber" },
    { status: "не подходит: собес", label: "Отказать", tone: "rose" },
];

export function statusLabel(status, statusDate) {
    const raw = LEGACY_STATUS_MAP[String(status || "").trim()] || String(status || "").trim();
    if (!raw) return "";
    const label = STATUS_LABELS[raw] || raw;
    if (!DATE_STATUS_VALUES.has(raw) || !statusDate) return label;
    const parts = String(statusDate).slice(0, 10).split("-");
    if (parts.length !== 3) return label;
    const shownDate = `${parts[2]}.${parts[1]}.${parts[0].slice(-2)}`;
    if (raw.startsWith("ВНР:")) return `ВНР: ${shownDate}, ${label.split(": ")[1].toLowerCase()}`;
    if (raw === "собес: назначен" || raw === "тест день: назначен") return `${label}: ${shownDate}`;
    return `${label} ${shownDate}`;
}

export function statusTone(status) {
    const raw = LEGACY_STATUS_MAP[status] || status;
    return CANDIDATE_STATUS_TREE.find((section) => section.children.some((item) => item.value === raw))?.tone || "grey";
}

export function candidateState(stage, status) {
    const raw = String(status || "").trim();
    const canonical = LEGACY_STATUS_MAP[raw] || raw;
    const rawStage = String(stage || "").trim();
    if (rawStage === "архивирован" && !String(STATUS_STATES[raw] || "").startsWith("Архив:")) return "Архив";
    if (rawStage === "нанят" && !STATUS_STATES[raw]) return "Сотрудник работает";
    if (rawStage === "в черном списке") return "Чёрный список";
    return STATUS_STATES[raw] || (STATUS_LABELS[canonical] ? (isArchiveStatus(canonical) ? "Завершён" : "В работе") : "Состояние не указано");
}

export function statusStage(status, catalog = []) {
    const raw = LEGACY_STATUS_MAP[String(status || "").trim()] || String(status || "").trim();
    const item = catalog.find((entry) => String(entry.code || entry.status) === raw);
    return item?.stage || CANDIDATE_STATUS_TREE.find((section) => section.children.some((child) => child.value === raw))?.label || STATUS_STAGES[raw] || "Этап не указан";
}

export function statusState(status, candidateStage, catalog = []) {
    const raw = String(status || "").trim();
    const item = catalog.find((entry) => String(entry.code || entry.status) === raw);
    if (candidateStage === "в черном списке") return "Чёрный список";
    return item?.state || candidateState(candidateStage, raw);
}

export function statusNextAction(status, catalog = []) {
    const raw = String(status || "").trim();
    const item = catalog.find((entry) => String(entry.code || entry.status) === raw);
    return item?.nextAction || item?.next_action || STATUS_NEXT_ACTIONS[raw] || "Уточнить следующий шаг";
}

export function allowedStatusTransitions(status, catalog = []) {
    const raw = LEGACY_STATUS_MAP[String(status || "").trim()] || String(status || "").trim();
    const item = catalog.find((entry) => String(entry.code || entry.status) === raw);
    if (item && Array.isArray(item.allowedTransitions)) return item.allowedTransitions;
    if (item && Array.isArray(item.allowed_transitions)) return item.allowed_transitions;
    return null;
}

export function flattenStatusTree(nodes = CANDIDATE_STATUS_TREE, depth = 0, acc = []) {
    for (const node of nodes) {
        acc.push({ value: node.value, label: node.label, tone: node.tone, depth, hasChildren: Boolean(node.children?.length) });
        if (node.children?.length) {
            flattenStatusTree(node.children, depth + 1, acc);
        }
    }
    return acc;
}

export function isArchiveStatus(status) {
    return ARCHIVE_STATUS_VALUES.has(LEGACY_STATUS_MAP[String(status || "").trim()] || String(status || "").trim());
}

export function isHireStatus(status) {
    return (LEGACY_STATUS_MAP[String(status || "").trim()] || String(status || "").trim()) === HIRE_STATUS_VALUE;
}

export function completedTestTypeForStatus(status) {
    const raw = String(status || "").trim();
    if (raw === "психологический тест: пройден") return "psychological";
    if (raw === "профессиональный тест: пройден") return "professional";
    if (raw === "тест: пройден" || raw === "тест: пройден (частично)") return "all";
    return null;
}
